<template>
    <div id="main">
        <container-loader v-if="isLoading" />
        <div class="page page-container">
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <!-- HEADER -->
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("grupocomissao")
                            }}{{
                                grupocomissao.idgrupocomissao != null
                                    ? `: ${grupocomissao.idgrupocomissao}`
                                    : `: ${$t("nova-grupocomissao")}`
                            }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("vendas")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'ven-grupocomissao-list',
                                            })
                                        "
                                        >{{ $t("grupocomissao") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        grupocomissao.idgrupocomissao != null
                                            ? grupocomissao.idgrupocomissao
                                            : $t("nova-grupocomissao")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <!-- BOTÕES DE AÇÂO -->
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="promptChangeTab"
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="
                                (!usuarioIntegracao &&
                                    !isUpdate &&
                                    permissao.create) ||
                                    (!usuarioIntegracao &&
                                        isUpdate &&
                                        permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />

                <!-- FORM -->
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(9)"
                                ref="idErpInput"
                                v-model="grupocomissao.idgrupocomissaoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!grupocomissao.idgrupocomissaoerp"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-8">
                            <v-input
                                :id="generateId(2)"
                                ref="descricaoInput"
                                v-model="grupocomissao.descricao"
                                title="descricao"
                                :required="true"
                                placeholder="placeholder-preencha" 
                                :maxlength="50"
                                tooltipLabel="informacao-grupocomissao-descricao"
                                tooltipPosition="is-top"
                                msg="msg-campo-obrigatorio"
                                :invalid="!grupocomissao.descricao"
                                :disabled="cantEdit"
                                uppercase />
                        </div>
                        <div class="column is-2">
                            <vss-select 
                                :id="generateId(5)" 
                                ref="situacaoSelect" 
                                v-model="situacaoSelected"
                                title="situacao"
                                :required="true" 
                                :options="situacaoSelect" 
                                :searchable="false"
                                class="no-clear" 
                                :disabled="grupocomissao.idgrupocomissao == null || cantEdit"
                                tooltipLabel="info-situacao-generica"
                                tooltipPosition="is-left"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GrupoComissaoService from "@/services/vendas/GrupoComissaoService";
import GrupoComissaoValidation from "@/services/validations/vendas/GrupoComissaoValidation";
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import Message from "@/models/Message";

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            msgs: [],
            service: new GrupoComissaoService(this.$http, this.$router),
            validation: new GrupoComissaoValidation(),
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                "GRUPOCOMISSAO"
            ),
            permissao: {},
            situacaoSelect: [
                { label: "INATIVO", id: 0 },
                { label: "ATIVO", id: 1 },
            ],
            situacaoSelected: { label: "ATIVO", id: 1 },
            grupocomissao: {
                idgrupocomissao: null,
                idgrupocomissaoerp: null,
                descricao: null,
                situacao: null,
            },
            isUpdate: false,
            isCreate: false,
            isChanged: false,
            isSaving: false,
            isLoading: false,
            cantEdit: false,
            finishedLoad: false,
        };
    },
    created() {
        if (this.$route.params.id) {
            this.isUpdate = true;
        } else {
            this.isCreate = true;
        }

        this.permissao = this.hasPermissionAccess(
            "vendas",
            "vendas",
            "ven-grupocomissao"
        );

        if (
            (!this.isUpdate && !this.permissao.create) ||
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "grupocomissao" },
            });
        } else {
            if (this.isUpdate) {
                this.cantEdit = this.usuarioIntegracao || !this.permissao.update;
                this.carregarDados();
            }
        }
    },
    watch: {
        // Watcher que checa se a rentabilidade foi alterada depois de ter sido carregada
        grupocomissao: {
            deep: true,
            handler: function() {
                if (this.finishedLoad) {
                    this.isChanged = true;
                }
            },
        },
    },
    methods: {
        // Gera ids para teste
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
        carregarDados() {
            this.isLoading = true;
            this.service
                .find(this.$route.params.id)
                .then(this.MapOnEdit)
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.finishedLoad = true;
                });
        },
        save() {
            this.isLoading = true;

            if (this.validation.validate(this.grupocomissao, this.$refs)) {
                let grupocomissaoTemp = Object.assign({}, this.grupocomissao);
                grupocomissaoTemp.situacao = this.situacaoSelected.id;

                this.isSaving = true;
                this.service
                    .save(grupocomissaoTemp)
                    .then((body) => {
                        // Escolhe mensagem de edit ou save
                        let msg = this.$t(
                                this.grupocomissao.idgrupocomissao != null
                                    ? "msg-edit-sucesso-n"
                                    : "msg-save-sucesso-n", 
                                { n: this.$t("grupocomissao") }
                            );
                        this.msgs.push(
                            new Message("success", msg, true, false)
                        );
                        this.redirectToList();
                    })
                    .catch((e) => {
                        let msgErro;
                        let message = e.body.message;
                        let msgType;

                        if (message && this.$te(message)) {
                            if (message == "msg-codigo-duplicado-n") {
                                msgErro = this.$t(message, { n: grupocomissaoTemp.idgrupocomissaoerp });
                            } else {
                                msgErro = this.$t(e.body.message);
                            }

                            msgType = "alert";
                        } else {
                            msgErro = this.$t(
                                "msg-problema-realizar-acao"
                            );
                            msgType = "error";
                        }

                        this.msgs.push(
                            new Message(msgType, msgErro, true, false)
                        );
                    })
                    .finally((_) => {
                        this.isLoading = false;
                        this.isSaving = false;
                        this.isChanged = true;
                    });
            } else {
                this.msgs.push(
                    new Message(
                        "alert",
                        "msg-campos-obrigatorios",
                        true,
                        true
                    )
                );
                this.isLoading = false;
            }
        },
        promptChangeTab() {
            if (this.isChanged) {
                this.$root.confirm({
                    message: this.$t("msg-tem-certeza-alteracoes"),
                    onConfirm: (_) => {
                        this.isChanged = false;
                        this.redirectToList();
                    },
                });
            } else {
                this.redirectToList();
            }
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({ name: "ven-grupocomissao-list" });
            }, 1000);
        },
        // Mapear o objeto quando a requisição é feita
        MapOnEdit({ content }) {
            this.grupocomissao = Object.assign(content);
            this.situacaoSelected = this.situacaoSelect[content.situacao];
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
}
</style>
